  let searchParams = new URLSearchParams(window.location.search)

/* GUTSCHEINCODE */
var Code = searchParams.get('cde');
    document.getElementById('code').innerHTML = Code;

var Amount = searchParams.get('cgp');
  switch(Amount) {
        case "1":
            var amount = "12%";
      break;
        case "2":
            var amount = "20%";
      break;
        case "3":
            var amount = "30%";
      break;
        default:
            var amount = "melde dich bitte bei uns, hier stimmt irgendwas nicht :)";
  };

    document.getElementById('amount').innerHTML = amount;
    
/* TAG NO */
   var TagNo = searchParams.get('tNo');
  document.getElementById('tagNum').innerHTML = TagNo;
    document.getElementById('tagNum2').innerHTML = TagNo;
        document.getElementById('tagNum3').innerHTML = TagNo;


/* COLOR */
      var Color = searchParams.get('col');
  switch(Color) {
  case "wte":
      var color = "light-colored";
      var color2 = "light-colored";
      var total_qty = "218";
      var dyeing = "wurde nicht gefärbt. die farbe des hoodies ergibt sich vollständig aus der natürlichen farbe der baumwolle";
    break;
  case "blu":
    var color = "ocean-colored";
    var color2 = "ocean-colored";
    var total_qty = "160";
    var dyeing = "wurde mit einem absolut naturbelassenen färbeverfahren gefärbt - dem natural inorganic pigment dye";
    break;
  case "blk":
    var color = "dark-colored";
    break;
  default:
    var color = "wunderschön";
    var color = "2";
    var total_qty = "378";
    var dyeing = "wurde ausschließlich mit nachhaltigen farben gefärbt"
};
document.getElementById('color').innerHTML = color;
document.getElementById('dye').innerHTML = dyeing;
document.getElementById('total_qty').innerHTML = total_qty;
document.getElementById('color2').innerHTML = color2;


/* COLLECTION */
  var Collection = searchParams.get('cln'); 
  switch(Collection) {
  case "fall22":
    document.getElementById('collection').innerHTML = "fall 2022";
    break;
  case "win23":
    document.getElementById('collection').innerHTML = "winter 2023";
    break;
  default:
    document.getElementById('collection').innerHTML = "Das gibt's noch nicht ;)";
};

/* STYLE */
var Style_Code = searchParams.get('stl');
  switch(Style_Code) {
              case "ba":
            var style = "basic unity:Hoodie";
      break;
              case "gl":
            var style = "give love unity:Hoodie";
      break;
              case "eq":
            var style = "equality unity:Hoodie";
      break;
              case "wo":
            var style = "woman life freedom unity:Hoodie";
      break;
              case "oi":
            var style = "oink unity:Hoodie";
      break;
            break;
              case "ll":
            var style = "love lines unity:Hoodie";
      break;
              case "eu":
            var style = "we are european unity:Hoodie";
      break;
              case "fl":
            var style = "flower unity:Hoodie (limitiert)";
      break;

  default:
            var style = "unity:Hoodie";
};
    document.getElementById('style').innerHTML = style;
    document.getElementById('style2').innerHTML = style;

/* SIZE */
var Size = searchParams.get('sze');
  document.getElementById('size').innerHTML = Size;
  document.getElementById('size2').innerHTML = Size;
  
/* ORDER DATE */
     var Order_Date = searchParams.get('odt');
  document.getElementById('orderdate').innerHTML = Order_Date;
  
/* FULFILL DATE */
     var Fulfill_Date = searchParams.get('fdt');
  document.getElementById('fulfilldate').innerHTML = Fulfill_Date;

/* FULFILLED BY */
    var fulfilled_by = searchParams.get('ful');
     switch(fulfilled_by) {
              case "ae": 
                 var fulfiller = "Alida";
               break;
              case "lkl":
                 var fulfiller = "Leon";
               break;
              case "both": 
                 var fulfiller = "Alida & Leon";
               break;
              default: 
                 var fulfiller = "Alida & Leon";
     };
  document.getElementById('fulfilledby').innerHTML = fulfiller;

  

/* IS SOLD */
   var isSold = searchParams.get('sld');

/* CUSTOMER NAME */
var Cus = searchParams.get('cus');
    document.getElementById('customer').innerHTML = Cus;

var Cus_bin = searchParams.get('cus_bin');






     






